import * as React from 'react';


export default class BoundedInput extends React.Component{
 
  constructor(props) {
    super(props);
    // Set initial state
    this.state = {
      count: null,
      progress: 38,
      status: 'safe',
      value: this.props.value ? this.props.value : '',
      valid: false
    }

    // Set variables
    this.min = this.props.min ? parseInt(this.props.min, 10) : 0;
    this.max = this.props.max ? parseInt(this.props.max, 10) : 'infinite';
    this.recommendedMin = this.props.recommendedMin ? parseInt(this.props.recommendedMin, 10) : 0;
    this.recommendedMax = this.props.recommendedMax ? parseInt(this.props.recommendedMax, 10) : 'infinite';

    // Set limit type
    if (this.checkForPixels([this.props.min, this.props.max, this.props.recommendedMin, this.props.recommendedMax]))
      this.type = 'pixel';

  }

  componentDidMount() {
    this.updateState();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value });
    }
  }
  handleTyping = (e) => {
    this.setState({value: e.target.value},() => {
      this.props.onChange(this.state.value)
      this.updateState();
    });
  }

  checkForPixels(limits) {
    var isPixelType = false;
    limits.forEach(function(e){
      if (e !== undefined && e.includes('px'))
        isPixelType = true;
    });
    return isPixelType;
  }

  // Save current input value and set displayed count text
  updateState() {
    const val = this.state.value;
    if (this.type !== 'pixel') {
      this.current = val.length;
      this.setState({count: this.current > 0 ? Math.round(this.current) : null});
      this.results();
    } else {
      this.setState({value: val},() => {
        this.current = this.clone.offsetWidth;
        this.setState({count: this.current > 0 ? Math.round(this.current) + 'px' : null});
        this.results();
      });
    }
  }

  results() {
    // Set current percentage of overall limit
    if (this.props.max === undefined && this.props.recommendedMax === undefined) {
      var percentage = this.props.recommendedMin !== undefined ? this.current / this.recommendedMin : this.current / this.min;
    } else {
      var percentage = this.max !== 'infinite' ? this.current / this.max : this.current / this.recommendedMax;
    }

    // Update progress circle graphic
    this.setState({progress: Math.max(0, 38 - (38 * percentage))});

    // Empty
    if (percentage === 0) {
      this.setState({status: 'empty'});
      if (this.props.required) {
        this.setState({valid: false});
      } else {
        this.setState({valid: true});
      }

    // Error
    } else if (this.current < this.min || this.current > this.max) {
      this.setState({
        status: 'error',
        valid: false
      });

    // Warn
    } else if (this.current < this.recommendedMin || this.current > this.recommendedMax) {
      this.setState({
        status: 'warn',
        valid: false
      });

    // Safe
    } else {
      this.setState({
        status: 'safe',
        valid: true
      });
    }
  }

  render() {

    const { count, progress, status, value } = this.state;

    const { type, rows } = this.props;
    return (
      <div className={"bounded-input bounded-input--" + status}>
        {type === 'textarea' ? (
          <textarea className="input" rows={rows} onChange={this.handleTyping} value={value} maxLength={this.max} id={this.props.id} name={this.props.name}/>
        ) : (
          <input className="input" placeholder={this.props.placeholder} type={type} onChange={this.handleTyping} id={this.props.id} name={this.props.name} value={value} maxLength={this.max}/>
        )}
        <div className="bounded-input__limit-indicator">
          <span className="bounded-input__character-count">{count}</span>
          <svg className="bounded-input__radial-counter" height="10" width="10">
            <circle className="bounded-input__progress-underlay" cx="50%" cy="50%" r="6" fill="none" strokeWidth="2"></circle>
            <circle className="bounded-input__progress" cx="50%" cy="50%" r="6" fill="none" strokeWidth="2" style={{strokeDashoffset: progress, strokeDasharray: 38}}></circle>
          </svg>
        </div>
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/component/InputForm/BoundedForm.js